var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11652_13708)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.3335,
    y: 16,
    width: 1,
    height: 16,
    rx: 0.5,
    transform: "rotate(180 14.3335 16)",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 9.30993C11.3335 10.486 10.3237 11.4082 9.15242 11.3017L2.15243 10.6654C1.12227 10.5717 0.333496 9.70798 0.333496 8.67357L0.333496 7.32643C0.333496 6.29202 1.12227 5.42829 2.15242 5.33464L9.15242 4.69828C10.3237 4.5918 11.3335 5.514 11.3335 6.69007L11.3335 9.30993Z",
    fill: "#007AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11652_13708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white",
    transform: "translate(14.3335 16) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignRight);
export default __webpack_public_path__ + "static/media/alignRight.8d2dae1d432d4260c3b1eb11bdd32b21.svg";
export { ForwardRef as ReactComponent };